/** Снимок заказов для подсветки «статус изменился» на вкладке «Мои заказы». */
const KEY = 'onviz_my_orders_snapshot_v1';

export type OrderSnap = Record<number, { status: string; updated_at: string }>;

export function readOrdersSnapshot(): OrderSnap {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return {};
    const o = JSON.parse(raw) as unknown;
    return o && typeof o === 'object' && !Array.isArray(o) ? (o as OrderSnap) : {};
  } catch {
    return {};
  }
}

export function writeOrdersSnapshot(snap: OrderSnap): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(snap));
  } catch {
    /* ignore */
  }
}

export function snapshotFromOrders<T extends { id: number; status: string; updated_at: string }>(orders: T[]): OrderSnap {
  const m: OrderSnap = {};
  for (const o of orders) {
    m[o.id] = { status: o.status, updated_at: o.updated_at };
  }
  return m;
}
